import * as React from "react";
import { forwardRef } from "react";
const SvgRows2 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M21 19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6h18zM19 3a2 2 0 0 1 2 2v6H3V5a2 2 0 0 1 2-2z" }));
const ForwardRef = forwardRef(SvgRows2);
export default ForwardRef;
